export { default } from './CookiesPolicy';
